export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10859.b1c093de.jpg";